import AXIOS from '@/axios-instance';

export default {
    savePXSurvey(schema, module){
        let deadline = null;
        if(schema.deadlineDate != null) deadline = schema.deadlineDate.getTime();
        return AXIOS.post("/px/survey", {
            surveySchema: JSON.stringify(schema),
            title: schema.title,
            deadlineDate: deadline,
            uuid: schema.uuid,
            module: module
        });
    },
    retrieveAllUsersToSentSurvey(surveyId) {
        return AXIOS.get("/user/survey/"+surveyId);
    },
    retrievePXSurveys() {
        return AXIOS.get("/px/survey");
    },
    retrievePXSurveysByModule(mod) {
        return AXIOS.get("/px/survey/module/"+mod);
    },
    sendPxSurvey(userIds, surveyId, /* deadlineDate, */ integrationState){
        /* var newDate = null;
        if(deadlineDate != null){
            let date = deadlineDate.split("-");
            newDate = new Date( date[0], date[1] - 1, date[2]);
            newDate = newDate.getTime();
        } */
        return AXIOS.post("/px/survey/send", {
            userIds: userIds,
            surveyId: surveyId,
            /* deadlineDate: newDate, */
            externalWFMSConnection: integrationState
        });
    },
    evaluateSurvey(id){
        return AXIOS.get("/px/evaluation/"+id);
    },
    deleteSurvey(id){
        return AXIOS.delete("/px/survey/"+ id);
    },
    retrieveSingleSurvey(id){
        return AXIOS.get("/px/survey/"+ id);
    },
    createEvaluationTimestamp(surveyId){
        return AXIOS.post("/px/evaluation/timestamp", surveyId, {
            headers: { "Content-Type": "application/json" }
          });
    },
    archiveSurvey(surveyId){
        return AXIOS.post("/px/survey/archive", surveyId, {
            headers: { "Content-Type": "application/json" }
          });
    },
    restoreSurveyFromArchive(surveyId){
        return AXIOS.post("/px/survey/archive", surveyId, {
            headers: { "Content-Type": "application/json" }
          });
    },
    retrieveArchivedSurveys(){
        return AXIOS.get("px/survey/archive");
    },
    finishSurvey(surveyId){
        return AXIOS.post("/px/survey/finish", surveyId, {
            headers: { "Content-Type": "application/json" }
            });
    },
    resendSurvey(survey){
        return AXIOS.post("/px/survey/resend", survey);
    }
}